import { render } from "./Fulfillment.vue?vue&type=template&id=5074767e&ts=true"
import script from "./Fulfillment.vue?vue&type=script&lang=ts"
export * from "./Fulfillment.vue?vue&type=script&lang=ts"

import "./Fulfillment.vue?vue&type=style&index=0&id=5074767e&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__